import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useGetURLTemplates } from 'server';
import { useAppSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useGetUserUrlTemplates = () => {
    const dispatch = useDispatch();
    const getURLTemplates = useGetURLTemplates();
    const userSegmentURLType = useAppSelector(prop('userSegmentURLType'));

    return useCallback(async (options?: { signal?: AbortSignal }): Promise<string[]> => {
        if (!userSegmentURLType) {
            dispatch(actions.userUnsetAttributesAction('urlTemplates'));

            return [];
        }

        const { urlList = [] } = await getURLTemplates({
            urlTypeList: [userSegmentURLType]
        }, options);
        // 0 is highest, 10 is lowest
        const highestPriority = urlList
            .map(tmpl => tmpl.priority ?? Infinity)
            .reduce((highest, priority) => priority < highest ? priority : highest, Infinity);
        const urlTemplates = urlList
            .filter(tmpl => tmpl.priority ?? Infinity <= highestPriority)
            .map(tmpl => tmpl.url)
            .filter(Boolean) as string[];

        dispatch(actions.userSetAttributesAction({ urlTemplates }));

        return urlTemplates;
    }, [
        dispatch,
        getURLTemplates,
        userSegmentURLType
    ]);
};
